import { inject, Injectable } from '@angular/core';

import {
  MessagePayload,
  Messaging,
  getToken,
  onMessage,
} from '@angular/fire/messaging';
import { environment } from '@environment';
import { StorageService } from '@commons/services/storage/storage.service';
import { STORAGE_TYPE } from '@commons/models';
import {
  NOTIFICATION_LIFE,
  NOTIFICATIONS_GET_ENDPOINT,
  TOKEN_NOTIFICATION,
} from '@commons/constants';
import { NotificationService } from '@commons/notifications/services/notification.service';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

/**
 * MessagingService class.
 */
@Injectable()
export class MessagingService {
  retry: number = 0;

  private readonly _messaging = inject(Messaging, {
    optional: true,
  }) as Messaging | null;
  getNotificationsEndpoint: string = NOTIFICATIONS_GET_ENDPOINT;
  processNotification$: BehaviorSubject<MessagePayload> =
    new BehaviorSubject<MessagePayload>(<MessagePayload>{});

  /**
   * Creates an instance of the component.
   * @param storageService - The storage service service instance.
   * @param notificationService - The notification service service instance.
   * @param messageService - The message service service instance.
   */
  constructor(
    private storageService: StorageService,
    private notificationService: NotificationService,
    private messageService: MessageService,
  ) {}

  /**
   * _get device token.
   */
  _getDeviceToken() {
    if (!this._messaging) return;
    getToken(this._messaging, {
      vapidKey: environment.vapidKey,
    })
      .then((token) => {
        if (token) {
          this.storageService.setItem(
            TOKEN_NOTIFICATION,
            token,
            STORAGE_TYPE.LOCAL,
          );
        }
      })
      .catch((_err) => {
        if (!this.retry) {
          this.retry++;
          this._getDeviceToken();
        }
      });
  }

  /**
   * _on message.
   */
  _onMessage(): void {
    if (!this._messaging) return;
    onMessage(this._messaging, {
      next: (payload: MessagePayload) => {
        this.notificationService
          .getNotifications(this.getNotificationsEndpoint)
          .subscribe();

        this.messageService.add({
          key: 'notification',
          severity: 'info',
          summary: payload.notification?.title,
          life: NOTIFICATION_LIFE,
          data: {
            id: payload.messageId,
          },
        });

        this.processNotification$.next(payload);
      },
      error: (error) => console.log('Message error', error),
      complete: () => console.log('Done listening to messages'),
    });
  }
}
